import comingSoon from '../coming_soon.png';
import './Home.css';

function Home() {
  return (
    <div className="home-hero">
      <div className="home-logo-frame">
        <img src={comingSoon} className="home-logo" alt="ursix" />
      </div>
    </div>
  );
}

export default Home;
